import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";

const EndOfLifeCareLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColLeft}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                  <Header.Subheader className={styles.highlightsItemSubHeader} >
                    <p className={styles.highlightsItemHeaderQuestion} >The most important first step in planning for end-of-life care is to understand the older adult's wishes.</p>
                  </Header.Subheader>
              </Segment>  
            </Grid.Column>
            <Grid.Column width={7} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                  <Header.Subheader className={styles.highlightsItemSubHeader} >
                    <p className={styles.highlightsItemHeaderQuestion} >What are their thoughts on continuing treatments that may prolong the length of their life without improving their quality of life?</p>
                    <p className={styles.learnMoreAccordionText}>For example, if they are dealing with cancer, do they want to continue chemotherapy even after their medical team has determined they don't have much time left?</p> 
                  </Header.Subheader>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColRight}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >
                  <Header.Subheader className={styles.highlightsItemSubHeader} >
                    <p className={styles.highlightsItemHeaderQuestion} > Keep in mind that the older adult's wishes may change and be sure to communicate with the older adult as you go. </p> 
                  </Header.Subheader>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };

  const renderAccordionTalking = () => {
    return (
        <>   
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column width={5} container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
              <Message className={styles.highlightsItemWhiteBG} info>
                  <Header.Subheader className={styles.highlightsItemSubHeader} >
                    <p className={styles.highlightsItemHeaderQuestion}><br/>Discussing end-of-life care is never easy but it can make the time before death much easier for both the older adult and their caregivers.<br/><br/> </p>
                  </Header.Subheader>
              </Message>
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Header.Subheader>  
                      <p className={styles.learnMoreAccordionTextEmphasis} ><br/> 
                      You may discover that the older adult has strong opinions on this topic, or they may have never thought about it. If the older adult has never mentioned their wishes, below are a few ways to discuss the topic.</p>
                      <p className={styles.learnMoreAccordionText} >Advance directives and health care powers of attorney are discussed under the Financial/Legal section of AgeReady. These are important documents that should be completed/updated when the older adult makes or revises a will.<br/> <br/> </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>    
        </>
    );
  };


  const accordions = [
    { key: 'talking',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Talking With Your Older Adult </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTalking()}/>)
      }
    },
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Asking the Right Questions </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}EndOfLifeCareLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(EndOfLifeCareLearnMore);
